import React from 'react'
import './Section2.css'

const Section2 = () => {
  return (
    <div className="section1-container" id='NEW'>
        <img src="https://res.cloudinary.com/facemetaclone/image/upload/v1662239842/pexels-ron-lach-8346206_jdqfzb.jpg" alt="" />
    </div>
  )
}

export default Section2